//   name: 'axios',

//   //// URL.... 
//   data(){
//     return{
//       url: 'wthstage.revotax.com/api/',
//     }
//   },
    

//   post(path,data,authdata) {
// const enpi = this.url+path;
    
//       this.axios.post(enpi,data,{
//        headers: {
//          Authorization: 'Bearer ' + authdata //the token is a variable which holds the token
//        }}).then((response) => {
//       return response
//       })
//        //this.alertDisplay();
           
//         },

//         get(path,authdata) {
//           const enpi = this.url+path;
//               try{
//                 this.axios.get(enpi,{
//                  headers: {
//                    Authorization: 'Bearer ' + authdata //the token is a variable which holds the token
//                  }}).then((response) => {
//                 return response
//                 })
//                  //this.alertDisplay();
//                      }catch(e){
//                          return e
//                      }
//                   },

import axios from 'axios'
import  cookieOps from "@/services/cookieOps.js";
import jwt_decode from "jwt-decode";
import { loadProgressBar } from 'axios-progress-bar'

const apiClient = axios.create({
    baseURL: 'http://localhost:5029/api',
    withCredentials: false,
    method: 'post',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiYWRtaW5UeXBlIjoxLCJmaXJzdE5hbWUiOiJPZ2EiLCJsYXN0TmFtZSI6Ik1ha28iLCJlbWFpbCI6Im9nYW1ha29AYXBwbWFydGdyb3VwLmNvbSIsInBob25lIjoiMDkwODM0NTQ5MzgzIiwicGFzc3dvcmRSZXNldCI6MSwiY3JlYXRlZEJ5IjpudWxsLCJpYXQiOjE2MzM5OTc3MTcsImV4cCI6MTYzNjU4OTcxN30.Lfy7tmLkxnONg2zShoNUGZy6NSs5dXQu6Xxvph2CGuo'      
    },
})
loadProgressBar('',apiClient)

export default {
    get(path){
        return apiClient.get(path)
    },
    post(path,data){
      console.log(data)
      return apiClient.post(path,data)
  },
  put(path,data){
    console.log(cookieOps.checkCookies('app_init'))
    return apiClient.put(path,data,{headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ cookieOps.checkCookies('app_init')
  }})
},
  detokenizeData(data){
return jwt_decode(data)
  } 
}
  //}